/** Shared CTA surface classes — Button and LinkButton (WD-02). */
export const buttonClassNames = ({
  variant = 'default',
  disabled = false,
  className = '',
}) => {
  const base =
    'inline-flex items-center justify-center font-bold py-2 px-4 rounded-md transition duration-150 hover:-translate-y-px active:translate-y-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-2 motion-reduce:transition-none motion-reduce:transform-none';

  const variantClasses =
    variant === 'primary'
      ? 'bg-action text-white hover:bg-navy hover:text-white active:bg-navy'
      : variant === 'partner'
        ? 'bg-navy text-yellow hover:bg-blue-900 hover:text-yellow active:bg-blue-900'
        : variant === 'custom'
          ? ''
          : 'bg-yellow text-navy hover:bg-navy hover:text-yellow active:bg-navy active:text-yellow';

  const disabledClasses = disabled
    ? 'opacity-50 cursor-not-allowed pointer-events-none'
    : '';

  return [base, variantClasses, disabledClasses, className].filter(Boolean).join(' ');
};
